export const CImageCopySlidesFragments = {
  field: `
    fragment imageCopySlides on imageCopySlides_MatrixField {
      ... on imageCopySlides_main_Entry {
        id
        typeHandle
        idName
        imageAlignInline
        animation {
          url
          title
        }
      }
      ... on imageCopySlides_slide_Entry {
        id
        typeHandle
        idName
        navigationText
        animationSegment {
          startFrame
          stopFrame
        }
        bodyVideo {
          url
          title
          embeddedAsset {
            url
            title
          }
        }
        heading
        copy
      }
    }
  `,
  field2: `
    fragment imageCopySlides2 on imageCopySlides2_MatrixField {
      ... on imageCopySlides2_main_Entry {
        id
        typeHandle
        idName
        imageAlignInline
        animation {
          url
          title
        }
      }
      ... on imageCopySlides2_slide_Entry {
        id
        typeHandle
        idName
        navigationText
        animationSegment {
          startFrame
          stopFrame
        }
        bodyVideo {
          url
          title
          embeddedAsset {
            url
            title
          }
        }
        heading
        copy
      }
    }
  `,
}
